import React from "react";
import { Newspaper, Users, Globe, BadgeCheck, FileCheck } from "lucide-react";

const ITEMS = [
  { icon: Newspaper, text: "80 media pickups, 40 English and 40 Arabic" },
  { icon: Users, text: "5,000+ journalists reached" },
  { icon: Globe, text: "6 GCC countries" },
  { icon: BadgeCheck, text: "Guaranteed: Zawya, MENA FN, Business Arabia" },
  { icon: FileCheck, text: "2 day and 10 day coverage reports" },
];

/**
 * Glass-style summary panel for the Gulf newswire hero right column.
 * Mirrors the dark card treatment of the homepage hero slider so the two
 * heroes read as visually consistent. Stacks below the hero text on mobile.
 */
export default function GulfNewswireSummaryPanel() {
  return (
    <div className="bg-gray-900/60 border border-gray-700 rounded-lg backdrop-blur-sm p-6 lg:p-7">
      <h3 className="font-heading text-lg font-bold text-white mb-5 pb-4 border-b border-gray-700">
        What your $475 delivers
      </h3>
      <ul className="space-y-4">
        {ITEMS.map((item) => (
          <li key={item.text} className="flex items-start gap-3">
            <item.icon className="w-5 h-5 text-cobalt shrink-0 mt-0.5" strokeWidth={1.75} />
            <span className="text-sm text-gray-200 leading-snug">{item.text}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}